import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataProviderService } from 'src/app/services/data-provider.service';
import { MessagingService } from 'src/app/services/messaging.service';
import { RestService } from 'src/app/services/rest.service';
import { BackButtonService } from 'src/app/services/back-button.service';
import { ViewWillEnter } from '@ionic/angular';

@Component({
  selector: 'app-visit-details',
  templateUrl: './visit-details.page.html',
  styleUrls: ['./visit-details.page.scss'],
})
export class VisitDetailsPage implements OnInit, OnDestroy, ViewWillEnter {
  public id: number;
  public job: any = {};
  public visitResults: any = [];
  public dateTemp = '';
  public processing = false;
  public saved = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataProviderService,
    private messaging: MessagingService,
    private restService: RestService,
    private backButtonService: BackButtonService
  ) {}

  ionViewWillEnter(): void {
    this.backButtonService.showBackButton({
      show: true,
      url: '/home',
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = parseInt(params?.id, 10);
      this.getData(this.id);
      this.getVisitResults();
    });
  }

  public getData(id: number) {
    this.dataService.getJob(id).subscribe((job) => {
      this.job = job;
      this.job.result = this.job.result?.toString();
      const dateArray = this.job.performedOn?.split('-');
      if (dateArray?.length === 3) {
        this.dateTemp = dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0];
      }
      if (this.job.performedOn === '' || this.job.performedOn === null) {
        this.job.performedOn = new Date().toISOString().slice(0, 10);
        this.dateTemp = this.job.performedOn;
      }
    });
  }

  public getVisitResults() {
    this.dataService.getVisitResults().subscribe((results) => {
      this.visitResults = results;
    });
  }

  public saveData() {
    this.processing = true;
    this.dataService
      .saveVisitData(this.id, this.job)
      .then(() => {
        this.processing = false;
        this.saved = true;
        setTimeout(() => {
          this.saved = false;
        }, 3000);
      })
      .catch((error) => {
        this.processing = false;
      });
  }

  setDate() {
    this.job.performedOn = this.job.performedOn.slice(0, 10);
    const dateArray = this.job.performedOn.split('-');
    this.dateTemp = dateArray[2] + '.' + dateArray[1] + '.' + dateArray[0];
  }

  navigateToQuestionnairePage() {
    this.router.navigate(['questionnaire', this.job.formId, 'Visit', this.id], {
      state: { backUrl: `/visitdetails/${this.id}` },
    });
  }

  ngOnDestroy() {}
}
